// extracted by mini-css-extract-plugin
export default {"list":"Ywtig0X71_4_uHeeF4fU","listItem":"Ht6YMXUEq1mm51dlapLD","listItemColorBox":"bxjJrKK1ctiMtfjrB4g6"};